import React, { useState, useMemo } from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import { ActivityTypeSelect } from '@shared/components/forms/ActivityTypeSelect';
import { makeStyles } from '@material-ui/core/styles';
import { GroupUserList } from '@shared/components/forms/GroupUserList';
import { useConnectedUsers, useUserInfoModal } from '@shared/hooks/queries/useUserQueries';
import { UserInfoModal } from '@shared/components/layout/UserInfoModal';

// ------------------------------------------------------------------------ //
// SYLES
// ------------------------------------------------------------------------ //
const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));


// ------------------------------------------------------------------------ //
// COMPONENT
// ------------------------------------------------------------------------ //
const TDBDrawer = () => {

  const [typeId, setTypeId] = useState(1);
  const classes = useStyles();

  // Utilisation des hooks React Query
  const { data: connectedUsersData = [], isLoading } = useConnectedUsers();
  const { userInfo, showUserInfo, hideUserInfo } = useUserInfoModal();

  // Transformation des données de l'API pour le format attendu par GroupUserList
  const formattedUsers = useMemo(() => {
    if (!connectedUsersData || connectedUsersData.length === 0) return [];

    return connectedUsersData.map((activitySection) => {
      const hasGroups = activitySection.users?.with_groups &&
                        Array.isArray(activitySection.users.with_groups) &&
                        activitySection.users.with_groups.length > 0;

      const hasUsersWithoutGroups = activitySection.users?.without_groups &&
                                     Array.isArray(activitySection.users.without_groups) &&
                                     activitySection.users.without_groups.length > 0;

      // Si pas de groupes ET pas d'utilisateurs sans groupe, on retourne avec id 0
      if (!hasGroups && hasUsersWithoutGroups) {
        return {
          id: 0,
          name: activitySection.activity,
          users: activitySection.users.without_groups
        };
      }

      // Si on a des groupes
      if (hasGroups) {
        const groups = activitySection.users.with_groups.map(group => ({
          name: group.label,
          users: group.users || []
        }));

        // Ajouter les utilisateurs sans groupe comme un groupe séparé s'il y en a
        if (hasUsersWithoutGroups) {
          groups.push({
            name: 'Sans groupe',
            users: activitySection.users.without_groups
          });
        }

        return {
          id: activitySection.id || 1,
          name: activitySection.activity,
          groups: groups
        };
      }

      // Cas par défaut : structure vide
      return {
        id: 0,
        name: activitySection.activity,
        users: []
      };
    });
  }, [connectedUsersData]);

  return (
    <div>
      {isLoading ? (
        <div style={{ padding: '20px', textAlign: 'center' }}>Chargement...</div>
      ) : (
        <GroupUserList
          activeUsers={formattedUsers}
          typeId={typeId}
          onUserClick={(id) => {
            showUserInfo(id);
          }}
        />
      )}
      <UserInfoModal
        userInfo={userInfo}
        handleCloseModal={hideUserInfo}
      />
    </div>
  );
};

export default TDBDrawer;
